import React from "react";

interface InfoDisplayProps {
  label: string;
  value?: React.ReactNode; // allows text, numbers, JSX (like <img />)
  className?: string; // optional custom styling
  labelWidth?: string; // optional col size for label
  valueWidth?: string; // optional col size for value
}

const InfoDisplay: React.FC<InfoDisplayProps> = ({
  label,
  value,
  className = "",
  labelWidth = "col-4",
  valueWidth = "col-8",
}) => {
  return (
    <div className={`row mb-3 ${className}`}>
      <div className={labelWidth}>
        <strong>{label}</strong>
      </div>
      <div className={valueWidth}>
        {value !== undefined && value !== null && value !== "" ? (
          <span>{value}</span>
        ) : (
          <span className="text-muted">-</span>
        )}
      </div>
    </div>
  );
};

export default InfoDisplay;